export interface CryptoAsset {
  code: string;
  name: string;
  fullName: string;
}

export const CRYPTO_ASSETS: CryptoAsset[] = [
  { code: 'BTC', name: 'Bitcoin', fullName: 'Bitcoin (BTC) — Criptomoeda original' },
  { code: 'ETH', name: 'Ethereum', fullName: 'Ethereum (ETH) — Smart contracts' },
  { code: 'USDT', name: 'Tether', fullName: 'Tether (USDT) — Stablecoin USD' },
  { code: 'USDC', name: 'USD Coin', fullName: 'USD Coin (USDC) — Stablecoin USD' },
  { code: 'BNB', name: 'BNB', fullName: 'BNB (BNB) — Binance Coin' },
  { code: 'SOL', name: 'Solana', fullName: 'Solana (SOL) — Alta velocidade' },
  { code: 'XRP', name: 'XRP', fullName: 'XRP (XRP) — Ripple' },
  { code: 'ADA', name: 'Cardano', fullName: 'Cardano (ADA) — Proof of Stake' },
  { code: 'AVAX', name: 'Avalanche', fullName: 'Avalanche (AVAX)' },
  { code: 'DOT', name: 'Polkadot', fullName: 'Polkadot (DOT) — Interoperabilidade' },
  { code: 'MATIC', name: 'Polygon', fullName: 'Polygon (MATIC) — Layer 2 Ethereum' },
  { code: 'DOGE', name: 'Dogecoin', fullName: 'Dogecoin (DOGE)' },
  { code: 'SHIB', name: 'Shiba Inu', fullName: 'Shiba Inu (SHIB) — Meme token' },
  { code: 'LTC', name: 'Litecoin', fullName: 'Litecoin (LTC)' },
  { code: 'LINK', name: 'Chainlink', fullName: 'Chainlink (LINK) — Oracle' },
  { code: 'UNI', name: 'Uniswap', fullName: 'Uniswap (UNI) — DEX Token' },
  { code: 'ATOM', name: 'Cosmos', fullName: 'Cosmos (ATOM) — Internet of Blockchains' },
  { code: 'TRX', name: 'TRON', fullName: 'TRON (TRX)' },
  { code: 'NEAR', name: 'NEAR Protocol', fullName: 'NEAR Protocol (NEAR)' },
  { code: 'BCH', name: 'Bitcoin Cash', fullName: 'Bitcoin Cash (BCH)' },
  { code: 'FIL', name: 'Filecoin', fullName: 'Filecoin (FIL) — Armazenamento descentralizado' },
  { code: 'ALGO', name: 'Algorand', fullName: 'Algorand (ALGO)' },
  { code: 'VET', name: 'VeChain', fullName: 'VeChain (VET) — Supply chain' },
  { code: 'ICP', name: 'Internet Computer', fullName: 'Internet Computer (ICP)' },
  { code: 'AAVE', name: 'Aave', fullName: 'Aave (AAVE) — DeFi lending' },
  { code: 'GRT', name: 'The Graph', fullName: 'The Graph (GRT)' },
  { code: 'SAND', name: 'The Sandbox', fullName: 'The Sandbox (SAND) — Metaverso' },
  { code: 'MANA', name: 'Decentraland', fullName: 'Decentraland (MANA) — Metaverso' },
  { code: 'AXS', name: 'Axie Infinity', fullName: 'Axie Infinity (AXS) — Play-to-earn' },
  { code: 'CRO', name: 'Cronos', fullName: 'Cronos (CRO) — Crypto.com' },
  { code: 'XLM', name: 'Stellar', fullName: 'Stellar (XLM) — Pagamentos' },
  { code: 'ETC', name: 'Ethereum Classic', fullName: 'Ethereum Classic (ETC)' },
  { code: 'HBAR', name: 'Hedera', fullName: 'Hedera (HBAR)' },
  { code: 'XMR', name: 'Monero', fullName: 'Monero (XMR) — Privacidade' },
  { code: 'XTZ', name: 'Tezos', fullName: 'Tezos (XTZ)' },
  { code: 'THETA', name: 'Theta', fullName: 'Theta Network (THETA) — Streaming' },
  { code: 'FTT', name: 'FTX Token', fullName: 'FTX Token (FTT)' },
  { code: 'DAI', name: 'Dai', fullName: 'Dai (DAI) — Stablecoin descentralizada' },
  { code: 'MKR', name: 'Maker', fullName: 'Maker (MKR) — DeFi governance' },
  { code: 'SNX', name: 'Synthetix', fullName: 'Synthetix (SNX)' },
  { code: 'CRV', name: 'Curve DAO', fullName: 'Curve DAO Token (CRV)' },
  { code: 'RUNE', name: 'THORChain', fullName: 'THORChain (RUNE)' },
  { code: 'ZEC', name: 'Zcash', fullName: 'Zcash (ZEC) — Privacidade' },
  { code: 'BAT', name: 'Basic Attention', fullName: 'Basic Attention Token (BAT) — Brave Browser' },
  { code: 'CHZ', name: 'Chiliz', fullName: 'Chiliz (CHZ) — Esportes e entretenimento' },
  { code: 'FLOW', name: 'Flow', fullName: 'Flow (FLOW) — NFTs e jogos' },
  { code: 'EGLD', name: 'MultiversX', fullName: 'MultiversX (EGLD) — ex-Elrond' },
  { code: 'ONE', name: 'Harmony', fullName: 'Harmony (ONE)' },
  { code: 'FTM', name: 'Fantom', fullName: 'Fantom (FTM)' },
  { code: 'KLAY', name: 'Klaytn', fullName: 'Klaytn (KLAY)' },
];
